module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.11@core-js/library/modules/_add-to-unscopables.js
// module id = 465
// module chunks = 69